/**
 * Salva a estrutura do resumo
 * @param {*} state state do vuex
 * @param {*} payload Objeto com dados da estrutura. {estrutura: {}, id_cliente}
 */
const SET_ESTRUTURA = (state, payload) => {
  // Verificar se o dado é do cliente que esta sendo carregado mesmo
  if (payload && payload.cliente.id === state.estrutura.id_cliente) {
    state.estrutura.value = {
      ...state.estrutura.value,
      ...payload.estrutura,
    }

    state.estrutura.data_coleta = new Date()
    state.estrutura.id_cliente = payload.cliente.id
  } else {
    console.log('SET_ESTRUTURA tentou salvar dados para o cliente errado.')
  }
}

const SET_LOADING_ESTRUTURA = (state, payload) => {
  state.estrutura.loading = payload.loading
  state.estrutura.id_cliente = payload.id_cliente
}

const CLEAR_ESTRUTURA = (state, payload) => {
  state.estrutura.value = {
    convite_app: '',
    envio_convite: '',
    acesso_realizado: '',
    data_registro: '',
    servico: '',
    servico_nome: '',
    servico_dias_atras: '',
    ativo_proximo_vencimento: '',
    revisao_ips: '',
    revisao_simulacao: '',
    proposta: '',
    consolidacao: '',
    relatorio: '',
  }
}

/**
 * Salvar os dados do cliente para o resumo
 * @param {Object} state state do vuex
 * @param {Object} payload Objeto com os dados do cliente. {dados: {}, id_cliente}
 */
const SET_DADOS = (state, payload) => {
  // Verificar se esta salvando para o cliente correto
  if (payload.dados && payload.cliente.id === state.dados.id_cliente) {
    state.dados.value = {
      ...state.dados.value,
      ...payload.dados,
    }

    state.dados.data_coleta = new Date()
    state.dados.id_cliente = payload.cliente.id
  } else {
    console.log('SET_DADOS tentou salvar dados para o cliente errado.')
  }
}

const SET_LOADING_DADOS = (state, payload) => {
  state.dados.loading = payload.loading
  state.dados.id_cliente = payload.id_cliente
}

const CLEAR_DADOS = (state, payload) => {
  state.dados.value = {
    assets_due_date: {},
    client_data: {},
    portfolio_review_data: {},
    subscriptions: {},
    ips_data: {},
    financial_data: {},
    revenue_data: {},
  }
}

export {
  SET_ESTRUTURA,
  SET_LOADING_ESTRUTURA,
  CLEAR_ESTRUTURA,
  SET_DADOS,
  SET_LOADING_DADOS,
  CLEAR_DADOS,
}
